import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Bell, Package } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { useAuth } from '../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NotificationsPage() {
  const { user } = useAuth();
  const { language, tr } = useLanguage();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/notifications?limit=50`);
        setItems(Array.isArray(data) ? data : []);
        await axios.put(`${API}/notifications/read-all`, {}).catch(() => {});
      } catch (e) { /* ignore */ }
      finally { setLoading(false); }
    })();
  }, [user]);

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-6 sm:py-10" data-testid="notifications-page">
      <h1 className="text-2xl sm:text-3xl font-bold text-[#121212] font-outfit mb-5" data-testid="notifications-title">
        {tr('Paziņojumi', 'Notifications', 'Уведомления')}
      </h1>

      {loading ? (
        <div className="flex justify-center py-16"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#D97736]" /></div>
      ) : items.length === 0 ? (
        <div className="bg-white border border-[#E5E4E0] rounded-2xl px-6 py-14 text-center" data-testid="notifications-empty">
          <Bell className="w-10 h-10 mx-auto mb-3 text-[#D97736]/30" />
          <p className="text-sm text-[#5C5C5C]">{tr('Nav paziņojumu', 'No notifications', 'Нет уведомлений')}</p>
        </div>
      ) : (
        <div className="bg-white border border-[#E5E4E0] rounded-2xl divide-y divide-[#F3F2EE] overflow-hidden">
          {items.map((n) => {
            const Icon = n.kind === 'order' ? Package : Bell;
            const href = n.link || (n.order_id ? '/orders' : '#');
            return (
              <Link
                key={n.id}
                to={href}
                className={`flex gap-3 px-4 py-4 hover:bg-[#F3F2EE] transition-colors ${n.read ? '' : 'bg-[#FFF8F3]'}`}
                data-testid={`notification-row-${n.id}`}
              >
                <div className={`w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0 ${n.read ? 'bg-[#F3F2EE]' : 'bg-[#D97736]/10'}`}>
                  <Icon className={`w-4 h-4 ${n.read ? 'text-[#5C5C5C]' : 'text-[#D97736]'}`} />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-[#121212]">{n.title}</p>
                  {n.body && <p className="text-xs text-[#5C5C5C] mt-0.5 leading-relaxed">{n.body}</p>}
                  <p className="text-[10px] text-[#5C5C5C] mt-1">
                    {n.created_at ? new Date(n.created_at).toLocaleString(language === 'lv' ? 'lv-LV' : language === 'ru' ? 'ru-RU' : 'en-GB', { dateStyle: 'short', timeStyle: 'short' }) : ''}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
